import { render, staticRenderFns } from "./NotifData.vue?vue&type=template&id=5eebc642&"
import script from "./NotifData.vue?vue&type=script&lang=js&"
export * from "./NotifData.vue?vue&type=script&lang=js&"
import style0 from "./NotifData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports